import Vue from 'vue'
import App from './Index.vue'
import {pageConfig} from '@/config/clientPageConfig.js'
import {initJSBridge,getHibirdConfig,sendData} from '@/utils/JSBridge.js'
import '../common'
import {dataBuryingPoint} from "@/utils/JSBridge";

initJSBridge(function (bridge) {
  bridge.registerEvent('clientBack', function (message, responseCallback) {
    dataBuryingPoint('C000004', 'C000004-001');
    let responseData = {'Javascript Says': 'Right back atcha!'};
    bridge.callEventCallback(responseCallback, responseData, message);
  });
  bridge.registerEvent('clientCustomerService', function (message, responseCallback) {
    dataBuryingPoint('C000004', 'C000004-009');
    let responseData = {'Javascript Says': 'Right back atcha!'};
    bridge.callEventCallback(responseCallback, responseData, message);
  })
});

sendData(getHibirdConfig(pageConfig.bridgeConfig));

new Vue({
  render: h => h(App)
}).$mount('#app')
